import axios from '@utils/axios';
import i18n from '@utils/localization';

const editRole = {
  state: {
    roleId: 0,
    roleName: '',
    rolePermissions: [],
    allPermissions: []
  },
  mutations: {
    setRoleId(state, id) {
      state.roleId = id;
    },
    setRolePermissions(state, permissions) {
      state.rolePermissions = permissions;
    },
    setRoleName(state, name) {
      state.roleName = name;
    },
    setAllPermissions(state, permissions) {
      state.allPermissions = permissions;
    }
  },
  actions: {
    fetchRole(context) {
      axios.get('admin/roles/role', {
        params: {
          Id: context.state.roleId,
          locale: i18n.locale
        }
      }).then((res) => {
        context.commit('setRolePermissions', res.data.permissions);
        context.commit('setRoleName', res.data.name);
      });
    },
    fetchPermissions(context) {
      axios.get('admin/roles/getpermissions', {
        params: {
          locale: i18n.locale
        }
      })
        .then((res) => context.commit('setAllPermissions', res.data));
    },
    resetContext(context) {
      context.commit('setRoleId', 0);
      context.commit('setRolePermissions', []);
      context.commit('setAllPermissions', []);
      context.commit('setRoleName', '');
    },
    addPermission(context, permission) {
      return axios.put('admin/roles/addpermission', {
        RoleId: context.state.roleId,
        Permission: permission.value
      }).then(() => {
        Promise.resolve(true);
      });
    },
    removePermission(context, permission) {
      return axios.delete('admin/roles/removepermission', {
        params: {
          RoleId: context.state.roleId,
          Permission: permission.value
        }
      }).then(() => {
        Promise.resolve(true);
      });
    }
  },
  namespaced: true
};

export default editRole;
